import React from 'react'
import { useTranslation } from 'react-i18next'
import logo from '../assets/logo.png' // или ../../assets/logo.png в зависимости от глубины


const NavBar = () => {
  const { i18n } = useTranslation()

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng)
  }

  return (
    <nav className="navbar">
      <div className="container">
      <div className="nav-center">
        <img src={logo} alt="LUMABODY Logo" className="logo-img" />
      </div>
        <div className="lang-switch">
          <button onClick={() => changeLanguage('en')}>EN</button>
          <button onClick={() => changeLanguage('ru')}>RU</button>
          <button onClick={() => changeLanguage('ua')}>UA</button>
          <button onClick={() => changeLanguage('cs')}>CS</button>
        </div>
      </div>
    </nav>
  )
}

export default NavBar
